var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleChoiceBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.735962C2.51472 0.735962 0.5 2.75068 0.5 5.23596V20.9976C0.5 23.4829 2.51472 25.4976 5 25.4976H20.7628C23.2481 25.4976 25.2628 23.4829 25.2628 20.9976V5.23596C25.2628 2.75068 23.2481 0.735962 20.7628 0.735962H5Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.882 5.49829C8.78286 5.49789 5.45639 8.85739 5.4568 12.9972C5.45721 17.137 8.78435 20.4972 12.8835 20.4976C16.9826 20.498 20.309 17.1385 20.3086 12.9987C20.3082 8.85886 16.9811 5.4987 12.882 5.49829ZM12.8833 18.9976C9.60105 18.9973 6.94231 16.3122 6.94198 12.9973C6.94165 9.68249 9.59986 6.99789 12.8821 6.99821C16.1644 6.99853 18.8231 9.68366 18.8234 12.9985C18.8238 16.3133 16.1656 18.9979 12.8833 18.9976ZM16.5957 12.9983C16.5959 15.0693 14.9337 16.748 12.8831 16.7478C10.8325 16.7476 9.16996 15.0685 9.16975 12.9976C9.16955 10.9266 10.8317 9.24792 12.8823 9.24813C14.9329 9.24833 16.5955 10.9273 16.5957 12.9983Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoiceBoxed);
export default __webpack_public_path__ + "static/media/MultipleChoiceBoxed.3f8c69431687b51d06fe2b6bd12970e2.svg";
export { ForwardRef as ReactComponent };